import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

@Component({
  selector: 'formly-information-row',
  templateUrl: './formly-information-row.component.html',
  styleUrls: ['./formly-information-row.component.scss'],
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class FormlyInformationRowComponent {}
